class Enums {
    static WhetherLimit = [
        { value: 'true', name: '是' },
        { value: 'false', name: '否' },
    ];
    static WhetherEffective = [
        { value: 'true', name: '是' },
        { value: 'false', name: '否' },
    ];
    static UserAmountChannel = [
        { value: 0, name: '支付宝充值' },
        { value: 1, name: '平台退款' },
        { value: 2, name: '平台消费' },
        { value: 3, name: '店铺续费消费' },
        { value: 4, name: '初始积分' }
    ];
    static ShopSiteType = [
        { value: 1, name: '台湾' },
        { value: 2, name: '马来' },
        { value: 3, name: '印尼' },
        { value: 4, name: '泰国' },
        { value: 5, name: '菲律宾' },
        { value: 6, name: '新加坡' },
        { value: 7, name: '越南' },
        { value: 8, name: '巴西' }
    ];
    static WarehouseOrderType = [
        { value: 0, name: '跨境' },
        { value: 1, name: '本土' },
        { value: 2, name: '海外' },
    ];
    static StatisticalType = [
        { value: 1, name: '汇总' },
        { value: 2, name: '每日' },
    ];
    static getEnum(obj: any, isAll: boolean) {
        var data = [];
        if (isAll) {
            data.push({ value: null, name: '全部' });
        }
        for (var value of obj) {
            data.push({ value: value.value, name: value.name });
        }
        return data;
    }
}
export default Enums;